// dependencies
import { GenerateProcess } from "redux-process";

// ui
import ui from "./ui";

// actions
import { changePageUI as updateUI } from "Actions/ui";

// selectors
import { getUI } from "Selectors/ui";
import { getCompanyID, getCurrentQuery, getIntegrationValue, getCompany } from "./selectors";

/**
 * Fetches a company
 */
export const fetchCompany = () => async (dispatch, getState) => {
	// parse state
	const state = getState();
	const companyID = getCompanyID(state);

	// request
	const request = await dispatch(GenerateProcess("GetCompany", { companyID }));

	let company = null;
	// update ui
	if (request.succeeded) {
		company = request.response;
	}
	let currentUI = getUI(getState());
	currentUI = currentUI.withMutations((mutable) => {
		mutable.set("company", company);
		// Company values will get mutated as values are updated on the page.
		// To keep track of the original values, we need to store them in a
		// separate variable.
		mutable.set("originalCompany", company);
		mutable.set("initalized", true);
	});
	await dispatch(updateUI([], currentUI));
};

export const fetchCompanyUsers = () => (dispatch, getState) => {
	// parse state
	const state = getState();
	const companyID = getCompanyID(state);
	const skip = 0;
	const limit = 50;
	const searchInput = getCurrentQuery(state);

	// request
	dispatch(GenerateProcess("GetCompanyUsers", { companyID, params: { limit, skip, q: searchInput } }));
};

export const changeQuery = (query) => (dispatch) => {
	dispatch(updateUI(["currentQuery"], query));
	dispatch(fetchCompanyUsers());
};

/**
 * Fetch (or refetch) the data
 */
export const fetchPageData = () => async (dispatch) => {
	dispatch(fetchCompany());
	dispatch(fetchCompanyUsers());
};

export const sendIntegrationUpdate = () => (dispatch, getState) => {
	// parse state
	const state = getState();
	const companyID = getCompanyID(state);
	const integrationName = getIntegrationValue(state);

	// request
	dispatch(GenerateProcess("SetIntegration", { companyID, payload: { integrationName } }));
};

export const deleteIntegration = () => (dispatch, getState) => {
	// parse state
	const state = getState();
	const companyID = getCompanyID(state);

	// request
	dispatch(GenerateProcess("DeleteIntegration", { companyID }));
};

export const resetIntegration = () => (dispatch, getState) => {
	// parse state
	const state = getState();
	const companyID = getCompanyID(state);

	// request
	dispatch(GenerateProcess("UpdateIntegration", { companyID, payload: { action: "resetIntegration" } }));
};

export const resetNotificationDefaults = () => (dispatch, getState) => {
	// parse state
	const state = getState();
	const companyID = getCompanyID(state);
	// request
	dispatch(GenerateProcess("reset notification defaults", { companyID, payload: {} }));
};

export const exportData = (dataName) => (dispatch, getState) => {
	// parse state
	const state = getState();
	const companyID = getCompanyID(state);

	switch (dataName) {
		case "employees":
			dispatch(GenerateProcess("Export employee csv", { companyID }));
			break;
		case "goals":
			dispatch(GenerateProcess("Export goal csv", { companyID }));
			break;
		default:
	}
};

export const copyStagingData = (payload) => (dispatch, getState) => {
	// parse state
	const state = getState();
	const companyID = getCompanyID(state);

	// request
	dispatch(GenerateProcess("copy staging data", { companyID, payload: payload }));
};

/**
 * The purpose of this function is to initiate an api call to run the
 * reporting etl for the specified domain
 * @param {string} reportingDomain
 * @returns {Promise}
 */
export const runReportingEtls = (reportingDomain) => async (dispatch, getState) => {
	const state = getState();
	const companyID = getCompanyID(state);

	try {
		const res = await dispatch(GenerateProcess("run reporting etl", { companyID, reportingDomain }));

		const data = res.response;
		if (data.success) {
			dispatch({
				type: "[100] create info toast",
				message: "Successfully queued ETLs",
			});
		} else if (data.success == false) {
			dispatch({
				type: "NOTIFICATION:ERROR",
				message: data.message,
			});
		}
	} catch (error) {
		dispatch({
			type: "NOTIFICATION:ERROR",
			message: "Error queuing ETLs",
		});
	}
};

export const sendSurveyManually = (env) => async (dispatch, getState) => {
	const state = await getState();
	const companyID = await getCompanyID(state);
	try {
		const res = await dispatch(GenerateProcess("sendSurveyManually", { companyID, env }));
		const data = res.response;
		if (data.success) {
			dispatch({
				type: "[100] create info toast",
				message: "Successfully sent survey",
				actionMessage: "Dismiss",
			});
		} else if (data.success == false) {
			dispatch({
				type: "NOTIFICATION:ERROR",
				message: data.message,
				actionMessage: "Dismiss",
			});
		}
	} catch (ermahgerd) {
		dispatch({
			type: "NOTIFICATION:ERROR",
			message: "Error sending surveys",
			actionMessage: "Dismiss",
		});
	}
};

export const sendReminderEmailsManually = (env) => async (dispatch, getState) => {
	// parse state
	const state = await getState();
	const companyID = await getCompanyID(state);
	const company = await getCompany(state);
	try {
		// request
		const res = await dispatch(
			GenerateProcess("sendReminderEmailsManually", { companyID, env, invokedBy: "Logan" })
		);
		const data = res.response;
		if (data.success) {
			dispatch({
				type: "[100] create info toast",
				message: data.message,
				actionMessage: "Dismiss",
			});
		} else if (data.success == false) {
			dispatch({
				type: "NOTIFICATION:ERROR",
				message: data.message,
				actionMessage: "Dismiss",
			});
		}
	} catch (ermahgerd) {
		dispatch({
			type: "NOTIFICATION:ERROR",
			message: "Error Sending Reminder Emails",
			actionMessage: "Dismiss",
		});
	}
};

export const clearBadLogins = (customerID) => async (dispatch) => {
	try {
		const res = await dispatch(GenerateProcess("ClearCustomerBadLogins", { customerID }));

		const { deleteCount } = res.response;
		dispatch({
			type: "[100] create info toast",
			message: `Cleared ${deleteCount} Bad Logins.`,
			actionMessage: "Dismiss",
		});
	} catch (ermahgerd) {
		//
	}
};
/**
 * Initialize page.
 */
export const init = () => (dispatch) => {
	// set the initial UI
	const initialUI = ui;
	dispatch(updateUI([], initialUI));

	// fetch page data
	dispatch(fetchPageData());
};
